import React, { Fragment, Component } from 'react';
import { withRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';
import "./Assets/css/bootstrap.min-v4.1.3.css";
import "./Assets/css/daterangepicker.css";
import "./Assets/css/custom.css";
import "./Assets/css/responsive.css";
import "./Assets/css/button.css";
import "./Assets/css/animate.css";
import "./Assets/css/new-style.css";
import $ from 'jquery';
import 'popper.js';
import 'bootstrap/dist/js/bootstrap.min.js';
import { APP_VERSION } from './Constants/AppConstants';
import Downtime from './Components/Pages/Downtime';
import Header from './Components/Layouts/Header';
import Footer from './Components/Layouts/Footer';
import CommonRoutes from './Routes/CommonRoutes';

class App extends Component {

    constructor(props) {
        super(props);
        this.state = {
            mounted: true,
            loading: true,
            downtime: false,
            downtime_msg: '<h3>Down for maintenance</h3><p>Site is temporarily unavailable due to planned maintenance.</p>'
        }
        console.log('App Version: ' + APP_VERSION);
    }

    componentDidMount() {
        this.setState({ mounted: !this.state.mounted });
        $(window).scroll(function () {
            if ($(window).scrollTop() >= 150) {
                $('.site_menu').addClass('fixed-header');
            } else {
                $('.site_menu').removeClass('fixed-header');
            }
        });

        $(window).scroll(function () {
            if ($(this).scrollTop() > 100) {
                $('.scrollup').show();
            } else {
                $('.scrollup').hide();
            }
        });

        $('.scrollup').click(function () {
            $("html, body").animate({
                scrollTop: 0
            }, 600);
            return false;

        });

        $(".mob_site_menu").on("click", function () {
            $("body").toggleClass("current", 1000);
        });
        this.setState({ loading: false })
    }

    disableDowntime = () => {
        this.setState({ downtime: false })
    }

    render() {

        return (
            <Fragment>
                {
                    (this.state.downtime) ?
                        <Downtime downtime_msg={this.state.downtime_msg} disableDowntime={this.disableDowntime} />
                        :
                        <Fragment>
                            {
                                (this.state.loading) ?
                                    <div className='home-loading'></div>
                                    :
                                    <Fragment>
                                        <Header />
                                        <div className="site-wrapper">
                                            <ToastContainer />
                                            <CommonRoutes />
                                        </div>
                                        <Footer />
                                    </Fragment>
                            }
                        </Fragment>
                }
            </Fragment>
        );
    }
}

export default withRouter(App);
